import { Route, Routes } from 'react-router-dom';
import Lingokids from './Lingokids';
import Vooks from './Vooks';
import Onepromath from './Onepromath';

const Content = () => {
  return (
    <Routes>
      <Route path={'vooks/'} element={<Vooks/>}></Route>
      <Route path={'lingokids/'} element={<Lingokids/>}></Route>
      <Route path={'onepromath/'} element={<Onepromath/>}></Route>
    </Routes>
  );
};

export default Content;
